import Header from './../components/_OldDesign/header'
import * as React from 'react'
import OldLayout from '@components/_OldDesign/OldLayout';
import { NextPageWithLayout } from './_app';

const AboutUs: NextPageWithLayout = () => {
  return <>
    <Header />

    <div className="grid grid-rows-1 bg-contain bg-no-repeat jamjuree text-dark-blue"
      style={{ backgroundImage: "url(/images/bg-aboutus.png)" }}>
      <div
        className="flex flex-col text-left ml-auto align-self-center my-20 xl:my-32 px-20 w-full lg:w-3/5 xl:px-12 xl:w-1/2">
        <p className="text-3xl lg:text-xl text-blue mb-3 lg:mb-2 font-light" lang="th">
          CODIUM คือผู้นำที่ให้บริการในการนำดิจิทัลเข้ามาเปลี่ยนแปลงองค์กรแบบครบวงจร (Digital Transformation
          Solution)</p>
        <p className="font-extralight mb-4 w-11/12 lg:w-9/12 text-2xl md:text-xl lg:text-base">
          เพื่อเสริมสร้างการเพิ่มประสิทธิภาพ การบริหารจัดการการดำเนินงาน
          ในทุกภาคส่วนธุรกิจ โดยมุ่งเน้นไปที่การตอบโจทย์ความต้องการ
          ให้กับแต่ละองค์กรโดยเฉพาะ</p>
        <p className="font-extralight w-11/12 lg:w-9/12 text-2xl md:text-xl lg:text-base">บริษัท โคเดียม เริ่มก่อตั้งปี
        2013 เราให้คำปรึกษาพร้อมช่วยธุรกิจ
        เปลี่ยนแปลงการทำงานให้เข้าสู่ยุคดิจิทัลแบบครบวงจร
          (end to end IT solutions) ให้องค์กรทั้งในประเทศและต่างประเทศ </p>
      </div>
      <section className="w-100 text-webkit-center mb-20 xl:mb-32">
        <div className="text-4xl text-black text-center mb-16">CODIUM MISSION</div>
        <p
          className="w-10/12 lg:w-3/4 text-2xl lg:text-xl font-light mb-16">เรามุ่งมั่นในการนำดิจิทัลและเทคโนโลยีเข้ามาเสริมสร้างองค์ประกอบที่ช่วยให้ทุกธุรกิจและทุกองค์กรมีความพร้อม
          <span className="font-bold">ด้วยเงินทุน (Funding), เทคโนโลยี (Technology), และข้อมูลเชิงลึกทางธุรกิจ (Business Insight)</span> ในการเพิ่มศักยภาพการประกอบธุรกิจให้ดียิ่งขึ้น
          ด้วยความขับเคลื่อนของพลังข้อมูล (Data-driven)
        </p>
        <div className="w-full space-x-14 sm:space-x-20 xl:space-x-32">
          <img className="inline w-52 sm:w-64 lg:w-auto 2xl:w-52"
            data-aos="fade-up"
            data-aos-easing="linear"
            data-aos-duration="500"
            loading="lazy"
            src="/images/money.svg"
            alt="อัพโหลดเอกสารต่างๆเข้าระบบอย่างง่ายดาย" />
          <img className="inline w-52 sm:w-64 lg:w-auto 2xl:w-52"
            data-aos="fade-up"
            data-aos-easing="linear"
            data-aos-duration="700"
            loading="lazy"
            src="/images/mainboard.svg"
            alt="อัพโหลดเอกสารต่างๆเข้าระบบอย่างง่ายดาย" />
          <img className="inline w-52 sm:w-64 lg:w-auto 2xl:w-52"
            data-aos="fade-up"
            data-aos-easing="linear"
            data-aos-duration="900"
            loading="lazy"
            src="/images/graph.svg"
            alt="อัพโหลดเอกสารต่างๆเข้าระบบอย่างง่ายดาย" />
        </div>
      </section>
      <section className="w-100 text-webkit-center mb-20 xl:mb-32">
        <div className="text-4xl text-black text-center mb-16">WHAT WE PROVIDE</div>
        <div className="w-4/5 lg:w-3/5 text-left font-light">
          <div className="mb-6 flex flex-wrap">
            <div className="w-1/3 text-2xl text-contact"><span className="text-4xl">C</span>ONSULT</div>
            <div className="w-2/3 text-xl mt-2">สร้างและพัฒนาเทคโนโลยีให้เชื่อมต่อกับองค์กรโดยเฉพาะ</div>
          </div>
          <div className="mb-6 flex flex-wrap">
            <div className="w-1/3 text-2xl text-red"><span className="text-4xl">C</span>ODE</div>
            <div className="w-2/3 text-xl mt-2">เป็นที่ปรึกษาให้ธุรกิจด้านการนำดิจิทัลมาเข้ามาปรับใช้อย่างลงตัว</div>
          </div>
          <div className="flex flex-wrap">
            <div className="w-1/3 text-2xl text-dark-blue"><span className="text-4xl">C</span>OMMUNICATE</div>
            <div className="w-2/3 text-xl mt-2">แลกเปลี่ยน สื่อสาร
            และปรับการใช้งานให้ตรงกับความต้องการของแต่ละองค์กร
            </div>
          </div>
        </div>
      </section>
      <section className="w-100 text-webkit-center mb-32 xl:mb-40">
        <div className="text-4xl text-black text-center mb-16">SERVICE & SOLUTION</div>
        <div className="w-full space-x-14 sm:space-x-20 xl:space-x-32 mb-12 xl:mb-20">
          <img className="inline w-80 lg:w-96"
            data-aos="fade-up"
            data-aos-easing="linear"
            data-aos-duration="500"
            loading="lazy"
            src="/images/e-memo.svg"
            alt="อัพโหลดเอกสารต่างๆเข้าระบบอย่างง่ายดาย" />
          <img className="inline w-80 lg:w-96"
            data-aos="fade-up"
            data-aos-easing="linear"
            data-aos-duration="700"
            loading="lazy"
            src="/images/e-tax.svg"
            alt="อัพโหลดเอกสารต่างๆเข้าระบบอย่างง่ายดาย" />
        </div>
        <p
          className="w-full px-20 font-light text-3xl">มากกว่าการจัดการระบบ เรามีทุกโซลูชั่นของการทำงาน
        </p>
      </section>
      <section className="w-100 text-webkit-center mb-20 xl:mb-32">
        <img className="inline w-32 lg:w-48 animate-bounce mb-5"
          src="/images/arrow.svg"
          loading="lazy"
          alt="อัพโหลดเอกสารต่างๆเข้าระบบอย่างง่ายดาย" />
        <p
          className="w-full p-20 font-light text-3xl bg-contact text-white mb-20 xl:mb-24">“ One Single Service IT Solution for Enterprise Management System ”<br />
          ตอบโจทย์การจัดการการดำเนินงานทุกอย่างที่องค์กรต้องการไว้ในแพลตฟอร์มเดียว
        </p>
        <img className="w-full mb-5 px-16 xl:px-36"
          src="/images/workflow.svg"
          loading="lazy"
          alt="อัพโหลดเอกสารต่างๆเข้าระบบอย่างง่ายดาย" />
      </section>
      <section className="w-100 text-webkit-center mb-20 xl:mb-32">
        <div className="text-4xl text-black text-center mb-16">Hall of Fame</div>
        <div className="w-full">
          <img className="mb-5 px-16 xl:px-36"
            loading="lazy"
            src="/images/hall-fame.svg"
            alt="อัพโหลดเอกสารต่างๆเข้าระบบอย่างง่ายดาย" />
        </div>
      </section>
    </div>
  </>
}

AboutUs.getLayout = (page: React.ReactElement) => {
  return <OldLayout>{page}</OldLayout>;
};

export default AboutUs;
